import Axios from 'axios';
import { nonSensitiveEnvVarsMapping } from '../env';

export async function getFactionScores() {
    const response = await Axios.get(`${nonSensitiveEnvVarsMapping[process.env.NODE_ENV].PLUTUS_API_ADDRESS}/soti/faction-scores`)
    return response.data
}